import React from 'react'
import PropTypes from 'prop-types'

import FormError from 'components/FormError/FormError'
import Input from 'components/Input/Input'
import {
  StyledWrapper,
  StyledInput,
  StyledIconLink,
  StyledLabel,
} from './RenderFieldStyle'

const Field = ({
  error,
  name,
  invalid,
  label,
  hideLabel,
  lightFont,
  inline,
  restrictWidth,
  onIconClick,
  type,
  icon,
  smallSize,
  mediumSize,
  labelTop,
  labelMiddle,
  alt,
  checkmark,
  ...props
}) => {
  const inputProps = {
    id: name,
    name,
    type,
    invalid,
    'aria-describedby': `${name}Error`,
    error,
    ...props,
  }
  const renderInputFirst = type === 'checkbox' || type === 'radio'

  return (
    <StyledWrapper {...{ type, smallSize, mediumSize, labelTop, labelMiddle }}>
      {renderInputFirst && !checkmark && <Input {...inputProps} />}
      {label && (
        <StyledLabel
          {...{ hideLabel, lightFont, inline, restrictWidth }}
          htmlFor={inputProps.id}
        >
          {renderInputFirst && checkmark && <Input {...inputProps} />}
          {label}
          {checkmark && <span className="checkmark" />}
        </StyledLabel>
      )}
      <fieldset>
        {!renderInputFirst && <StyledInput {...inputProps} />}
        {icon && (
          <StyledIconLink title={alt} onClick={onIconClick} {...{ icon }} />
        )}
      </fieldset>
      {invalid && error && type !== 'daypicker' && (
        <FormError error={error} name={name} />
      )}
    </StyledWrapper>
  )
}

Field.propTypes = {
  name: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  error: PropTypes.shape({
    id: PropTypes.string,
    values: PropTypes.object,
  }),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  type: PropTypes.string,
  icon: PropTypes.string,
  hideLabel: PropTypes.bool,
  lightFont: PropTypes.bool,
  inline: PropTypes.bool,
  restrictWidth: PropTypes.bool,
  smallSize: PropTypes.bool,
  mediumSize: PropTypes.bool,
  labelTop: PropTypes.bool,
  labelMiddle: PropTypes.bool,
  onIconClick: PropTypes.func,
  alt: PropTypes.string,
  checkmark: PropTypes.bool,
}

Field.defaultProps = {
  type: 'text',
  labelTop: true,
  restrictWidth: false,
  checkmark: false,
}

export default Field
